<div mat-dialog-title>Add Loss Tree</div>
<div mat-dialog-content>
  <label class="padBottom" >Level 0 : {{data.level0}} </label>
  <div class="row col-md-12 padBottom">
    <div class="col-md-4">
      <label >Level 1 <span class="mandatory">*</span></label>
      <input class="form-control" type="text" [(ngModel)]="level1" (focusout)="level1hasValue(level1)">
    </div>
    <div class="col-md-4">
      <label >Level 2 <span class="mandatory">*</span></label>
      <input class="form-control" type="text" [(ngModel)]="level2"(focusout)="level2hasValue(level2)">
    </div>
    <div class="col-md-4">
      <label >Level 3 <span class="mandatory">*</span></label>
      <input class="form-control" type="text" [(ngModel)]="level3"(focusout)="level3hasValue(level3)">
    </div>
  </div>
  <div class="row col-md-12 padBottom">
    <div class="col-md-4">
      <label >Level 4 <span class="mandatory">*</span></label>
      <input class="form-control" type="text" [(ngModel)]="level4"(focusout)="level4hasValue(level4)">
    </div>
    <div class="col-md-4">
      <label >Level 5</label>
      <input class="form-control" maxlength="100" type="text" [(ngModel)]="level5"(focusout)="level5hasValue(level5)">
    </div>
    <div class="col-md-4">
      <label >Severity Grade <span class="mandatory">*</span></label>
      <div class="dropdown">
        <button type="button" class="btn btn-primary dropdown-toggle" (focusout)="focusOutSeverityWhileAdd()"
          data-toggle="dropdown" (click)="severityDefaultValueWhileAdd()">
          {{defaultSeverity}}
          <span [ngClass]="showSeverity ? 'fa fa-angle-up arrow-position' : 'fa fa-angle-down arrow-position'"></span>
        </button>
        <ul class="dropdown-menu">         
          <li>
            <p class="dropdown-item" href="#" *ngFor="let item of severity" (click)="selectedSeverityWhileAdd(item)" title="{{item.text}}">
              {{item.text}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row col-md-12">
    <div class="col-md-4">
      <label >Explanation/Examples</label>
      <textarea class="form-control" maxlength="100" [(ngModel)]="example" (focusout)="typedExample(example)">
      </textarea>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4"></div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" [ngClass]="mandatoryFieldsHasValue ? '': 'disable'" [mat-dialog-close]="validateSG" (click)="saveAddedLossTree()"cdkFocusInitial>Save</button>
  <button mat-button (click)="onNoClick()">Cancel</button>
</div>


<!-- Copyright 2019 Google LLC. All Rights Reserved.  
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->